import { lazy, Suspense, useEffect, useRef, useState } from "react";
import EmergencyServicesimg from "../../../src/assets/images/EmergencyServices.svg";
import faFileAltimg from "../../../src/assets/images/FileaClaim.svg";
import faPlusCircleimg from "../../../src/assets/images/newpolicyicon.svg";
import faSyncAltimg from "../../../src/assets/images/Renewal.svg";
import ServiceGrid from "../../components/common/serviceCards/serviceCards";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import EmergencyServicesimgdardk from "../../../src/assets/images/EmergencyServicesdark.svg";
import faFileAltimgdark from "../../../src/assets/images/FileaClaimdark.svg";
import faPlusCircleimgdark from "../../../src/assets/images/newpolicydark.svg";
import faSyncAltimgdark from "../../../src/assets/images/Renewaldark.svg";
import Loader from "../../components/common/Loader/Loader";
import useLanguageTranslate from "../../hooks/useLanguageTranslate";
import {
  ekeyLogin,
  selectLoginTokenInfo,
} from "../../redux/features/loginRegisterSlice";
import {
  fetchOffers,
  selectOffersData,
  selectOffersDataLoader,
} from "../../redux/features/offersSlice";
import OffersSkeleton from "../../components/common/heroSlider/offersSkeleton";
import { emergencyServicesData } from "./data";
import MyPolicies from "./myPolicies";

import { usePostHog } from "posthog-js/react";
import logoIcon from "../../../src/assets/images/Logo.svg";
import useScreenResolution from "../../hooks/useScreenResolution";
import PolicyTransferRequestModal from "./policyTransferRequestModal";

import faSyncAltimgdarkqa from "../../../src/assets/images/homegraybk.svg";
import EmergencyServicesimgqa from "../../../src/assets/images/medicalicon.svg";
import faPlusCircleimgqa from "../../../src/assets/images/Roaddark.svg";
import faFileAltimgdarkqa from "../../../src/assets/images/Traveldark.svg";

import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { verifyChallenge } from "pkce-challenge";
import { toast } from "sonner";
import BackdropModal from "../../components/common/modal/backdropModal";
import { clearCancellationState } from "../../redux/features/endorsements/cancellationSlice";
import { clearCalculatePremiumState } from "../../redux/features/motor/calculatePremiumSlice";
import { clearGetQuoteState } from "../../redux/features/motor/getQuoteSlice";
import { clearPolicyPremium } from "../../redux/features/motor/renewalPremiumSlice";
import { clearMotorInsuranceFlow } from "../../redux/features/motorInsuranceFlowSlice";
import { clearRenewalFlow } from "../../redux/features/motorInsuranceRenewFlowSlice";
import {
  clearMotorFormData,
  clearNewMotorFormData,
} from "../../redux/features/newMotorFormSlice";
import { clearPolicyPayState } from "../../redux/features/payment/policyPaySlice";
import { selectProfilePolicyTransferStatus } from "../../redux/features/profileSlice";
import EmergencyServices from "../emergencyServices/EmergencyServices";

const HeroSliderContent = lazy(() =>
  import("../../components/common/heroSlider/heroSliderContent")
);
const services = [
  {
    icon: faPlusCircleimg,
    micon: faPlusCircleimgdark,
    text: "New Policy",
    text_ar: " خطة جديدة",
    type: "new_policy",
  },
  {
    icon: faSyncAltimg,
    micon: faSyncAltimgdark,
    text: "Renewal",
    text_ar: "تجديد",
    type: "Renewal",
  },
  {
    icon: faSyncAltimg,
    micon: faSyncAltimgdark,
    text: "Quick Renewal",
    text_ar: "التجديد السريع",
    type: "QuickRenewal",
  },
  {
    icon: faFileAltimg,
    micon: faFileAltimgdark,
    text: "File a Claim",
    text_ar: "تقديم مطالبة",
    type: "Claim",
  },
  {
    icon: EmergencyServicesimg,
    micon: EmergencyServicesimgdardk,
    text: "Emergency Services",
    text_ar: "خدمات الطوارئ",
    type: "Emergency",
    hideInMobile: true,
  },
];
const assistanceServices = [
  {
    icon: faPlusCircleimg,
    micon: faPlusCircleimgqa,
    text: "Road",
    text_ar: "المساعدة على الطريق",
    type: "road",
  },
  {
    icon: faSyncAltimg,
    micon: faSyncAltimgdarkqa,
    text: "Home",
    text_ar: "المساعدة المنزلية",
    type: "home",
  },
  {
    icon: faFileAltimg,
    micon: faFileAltimgdarkqa,
    text: "Travel",
    text_ar: "مساعدة السفر",
    type: "travel",
  },
  {
    icon: EmergencyServicesimg,
    micon: EmergencyServicesimgqa,
    text: "Medical",
    text_ar: "المساعدة الطبية",
    type: "medical",
  },
];

const Dashboard = () => {
  const [showPolicyTransfer, setShowPolicyTransfer] = useState(false);
  const [showAssistanceService, setShowAssistanceService] = useState("");

  const dispatch = useDispatch();
  const location = useLocation();
  const { state, pathname } = location;
  const translate = useLanguageTranslate();
  const { i18n, t } = useTranslation();
  const sliderRef1 = useRef(null);
  const screenResolution = useScreenResolution();
  const posthog = usePostHog();

  const getPolicyTransferDetails = useSelector(
    selectProfilePolicyTransferStatus
  );
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [showLoginOverlay, setShowLoginOverlay] = useState(false);

  const policyCardRef = useRef(null);

  useEffect(() => {
    window.handleAppRedirect = (url) => {
      try {
        const parsed = new URL(url);

        const code = parsed.searchParams.get("code");
        const state = parsed.searchParams.get("state");

        console.log("Redirected from Native App with code:", code);

        if (code) {
          // Navigate or trigger login using same handler
          eKeyLogin(code);
        }
      } catch (err) {
        console.error("Invalid redirect from app:", err);
      }
    };
    console.log("Home Sweet Home");

    const params = new URLSearchParams(location.search); // Capture query parameters

    const code = params.get("code"); // Extract the authorization code from the URL
    if (code) {
      console.log("Authorization Code:", code);
      // After capturing the authorization code, proceed with exchanging it for tokens
      eKeyLogin(code);
    }
    if (state) {
      console.log("State:", state); // Optionally validate the state parameter for CSRF protection
    }
    dispatch(fetchOffers());

    // Clear redux state on dashboard page
    dispatch(clearGetQuoteState());
    dispatch(clearCancellationState());
    dispatch(clearPolicyPremium());
    dispatch(clearCancellationState());
    dispatch(clearPolicyPayState());
    dispatch(clearCalculatePremiumState());
    dispatch(clearRenewalFlow());
    dispatch(clearMotorInsuranceFlow());
    dispatch(clearMotorFormData());
    dispatch(clearNewMotorFormData());

    // Check if profile has pending or in-progress policy transfer
    if (
      getPolicyTransferDetails &&
      getPolicyTransferDetails.length > 0 &&
      (getPolicyTransferDetails[0].Status == "PENDING" ||
        getPolicyTransferDetails[0].Status == "IN_PROGRESS")
    ) {
      setShowPolicyTransfer(true);
    }
  }, [getPolicyTransferDetails, dispatch]);

  const offersReducerData = useSelector(selectOffersData) || [];
  const isOffersLoading = useSelector(selectOffersDataLoader);
  const loginTokenInfo = useSelector(selectLoginTokenInfo);

  const eKeyLogin = async (code) => {
    const codeVerifier = localStorage.getItem("code_verifier");
    const codeChallenge = localStorage.getItem("code_challenge");

    try {
      setShowLoginOverlay(true); // Show overlay

      const val = (await verifyChallenge(codeVerifier, codeChallenge)) === true;
      if (!val) throw new Error("Code challenge verification failed");

      const payload = { code: code, verifier: codeVerifier };
      const loginResp = await dispatch(
        ekeyLogin({
          payload,
          cb: () => {
            navigate("/");
          },
        })
      );

      if (loginResp?.payload?.access_token) {
        if (loginResp?.payload?.access_token) {
          // posthog.reset(true);
          posthog.reset();
          console.log("Logged In User: " + loginResp?.payload?.partyCode);
          localStorage.setItem("ekeyLogin", true);

          posthog.identify(
            loginResp?.payload?.partyCode, // Replace 'distinct_id' with your user's unique identifier
            {
              partycode: loginResp?.payload?.partyCode,
              cpr: loginResp?.payload?.cpr,
              email: loginResp?.payload.email,
              name: loginResp?.payload?.name,
              phoneNumber: loginResp?.payload?.phoneNumber,
            } // optional: set additional person properties
          );
          posthog.reloadFeatureFlags();
        }
      } else {
        console.error("Error Logging in:", loginResp);
        toast.error(
          translate(
            "eKey login failed. Please try signing in with your CPR number and password.",
            "فشل تسجيل الدخول بالمفتاح الإلكتروني. يرجى تسجيل الدخول باستخدام رقم CPR وكلمة المرور."
          )
        );
      }
    } catch (error) {
      console.error("Exchange Error:", error);
      toast.error(
        translate(
          "eKey service is temporarily unavailable. Please sign in with your CPR number and password.",
          "خدمة المفتاح الإلكتروني غير متاحة مؤقتاً. يرجى تسجيل الدخول باستخدام رقم CPR وكلمة المرور."
        )
      );
    } finally {
      setShowLoginOverlay(false); // Hide overlay
    }
  };

  const navigate = useNavigate();
  const serviceClickHandler = (service) => {
    if (service == "new_policy") {
      navigate("/new-policy");
    } else if (service == "Renewal") {
      navigate("/renew");
    } else if (service == "QuickRenewal") {
      navigate("/motor-insurance/quick-renew-motor-policy");
    } else if (service == "Claim") {
      navigate("/file-a-claim");
    } else if (service == "Emergency") {
      navigate("/emergency-services");
    }
  };
  const assistanceServiceClickHandler = (service) => {
    setShowAssistanceService(service);
  };
  useEffect(() => {
    if (pathname?.includes("policyTransfer")) {
      setShowPolicyTransfer(true);
    }
  }, [pathname]);

  const scroll = (direction) => {
    const container = policyCardRef.current;
    const scrollAmount = 300;
    if (!container) return;

    if (direction == "left") {
      container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    } else {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }

    setTimeout(() => {
      updateScrollButtons();
    }, 300);
  };

  const updateScrollButtons = () => {
    const container = policyCardRef.current;
    if (!container) return;

    setCanScrollLeft(container.scrollLeft > 0);
    setCanScrollRight(
      container.scrollWidth > container.clientWidth + container.scrollLeft
    );
  };

  useState(() => {
    updateScrollButtons();
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      <div>
        <PolicyTransferRequestModal
          show={showPolicyTransfer}
          setShow={setShowPolicyTransfer}
        />
        {/* On a phone the first section has to clear the fixed top bar. That
            used to be a mt-[70px] on My Policies and on the mobile Offers
            block, whichever came first, so a signed-out visitor with no
            offers got Quick Actions tucked under the bar. The clearance lives
            here now, once, whatever renders first. */}
        <div className="min-h-screen max767:pt-[70px]">
          {loginTokenInfo && (
            <div className="myPoliciesContainer p-6 pr-0 rtl:pl-0 rtl:pr-6 max767:p-5">
              <div className="flex justify-between alpbaseign-center pr-6 max767:pr-0 rtl:pl-6 rtl:pr-0">
                <h1 className="text-black text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] mb-[8px] max767:mb-3">
                  {t("commonLabels.my_policies_label")}
                </h1>
                {screenResolution.mobile && (
                  <button
                    className="flex flex-col text-sm items-center gap-2.5 border font-semibold bg-white rounded-[10px] leading-normal px-3 py-1 max767:text-[#00384D] max767:text-sm max767:not-italic max767:font-medium max767:leading-[120%] max767:underline max767:border-0 max767:pr-0"
                    onClick={() => navigate("/my-policy")}
                  >
                    {t("dashboard.viewAll")}
                  </button>
                )}
                {!screenResolution.mobile && (
                  <div className="arrowbutn flex gap-2">
                    {/* Left Chevron */}
                    <button
                      onClick={() => scroll("left")}
                      disabled={!canScrollLeft}
                      className={`p-2 rounded-full h-[36px] w-[36px]  ${
                        canScrollLeft
                          ? "bg-[#55C6EF] text-[black]" // Active state
                          : "bg-[#E5E9EB] text-gray-400" // Disabled state
                      }`}
                    >
                      {" "}
                      <span className="flex justify-center">
                        {" "}
                        <FontAwesomeIcon
                          icon={faChevronLeft}
                          size=""
                          className="text-[12px] rtl:rotate-180"
                        />
                      </span>
                    </button>

                    {/* Right Chevron */}
                    <button
                      onClick={() => scroll("right")}
                      disabled={!canScrollRight}
                      className={`p-2 rounded-full h-[36px] w-[36px] ${
                        canScrollRight
                          ? "bg-[#55C6EF] text-[black]" // Active state
                          : "bg-[#E5E9EB] text-gray-400" // Disabled state
                      }`}
                    >
                      <span className="flex justify-center">
                        {" "}
                        <FontAwesomeIcon
                          icon={faChevronRight}
                          className="text-[12px] rtl:rotate-180"
                        />{" "}
                      </span>
                    </button>
                  </div>
                )}
              </div>
              <div
                className="  overflow-y-hidden overflow-x-auto md:overflow-x-hidden "
                ref={policyCardRef}
              >
                <div className="flex gap-4 policycard-slider">
                  <MyPolicies />
                </div>
              </div>
            </div>
          )}

          {state?.navigatedFromLink != "My Policy" &&
            screenResolution.mobile &&
            !loginTokenInfo &&
            (isOffersLoading ? (
              <div className=" flex flex-col offersSection px-[18px] py-0  max767:mb-4 max767:p-5 max767:pb-0">
                <h1 className="text-black text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] pl-0 mb-[8px]">
                  {t("dashboard.offers_label")}
                </h1>
                <OffersSkeleton showTitle={false} />
              </div>
            ) : (offersReducerData?.banner?.length || offersReducerData?.mobileBanner?.length) ? (
              <div className=" flex flex-col offersSection px-[18px] py-0  max767:mb-4 max767:p-5 max767:pb-0">
                <h1 className="text-black text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] pl-0 mb-[8px]">
                  {t("dashboard.offers_label")}
                </h1>
                <Suspense fallback={<OffersSkeleton showTitle={false} />}>
                  <HeroSliderContent
                    sliders={offersReducerData}
                    sliderRef={sliderRef1}
                  />
                </Suspense>
              </div>
            ) : null)}

          <div className="flex flex-col lifeinsurencepolicycard p-6 max767:pt-0 max767:p-5 max767:first:pt-2">
            <h1 className="text-black text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] pl-0 max767:pl-0 max767:mt-3">
              {t("dashboard.quick_actions_label")}
            </h1>
            <ServiceGrid
              services={services.filter((s) => s.type !== "Renewal" || loginTokenInfo)}
              serviceClickHandler={serviceClickHandler}
            />
          </div>
          {screenResolution.mobile && (
            <div className="flex flex-col Assistance max767:px-5 max767:py-0">
              <h1 className="text-black text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] pl-6 mt-4 max767:pl-0">
                {translate("Assistance Services", "خدمات المساعدة")}
              </h1>
              <ServiceGrid
                services={assistanceServices}
                serviceClickHandler={assistanceServiceClickHandler}
              />
            </div>
          )}
          {state?.navigatedFromLink != "My Policy" &&
            !(screenResolution.mobile && !loginTokenInfo) &&
            (isOffersLoading ? (
              <div className=" flex flex-col offersSection  max767:mt-0 mt-[0px] p-6 max767:p-5">
                <h1 className="text-black text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] pl-0 mb-[8px]">
                  {t("dashboard.offers_label")}
                </h1>
                <OffersSkeleton showTitle={false} />
              </div>
            ) : (offersReducerData?.banner?.length || offersReducerData?.mobileBanner?.length) ? (
              <div className=" flex flex-col offersSection  max767:mt-0 mt-[0px] p-6 max767:p-5">
                <h1 className="text-black text-2xl not-italic font-semibold leading-8 tracking-[-0.24px] pl-0 mb-[8px]">
                  {t("dashboard.offers_label")}
                </h1>
                <Suspense fallback={<OffersSkeleton showTitle={false} />}>
                  <HeroSliderContent
                    sliders={offersReducerData}
                    sliderRef={sliderRef1}
                  />
                </Suspense>
              </div>
            ) : null)}
        </div>
        <div className="emergencymodal">
          <BackdropModal
            show={showAssistanceService}
            onClose={() => setShowAssistanceService("")}
            title={""}
            emergencyServiceData={emergencyServicesData?.filter(
              (each) => each.type == showAssistanceService
            )}
          >
            <EmergencyServices
              data={emergencyServicesData?.filter(
                (each) => each.type == showAssistanceService
              )}
              type={showAssistanceService}
            />
          </BackdropModal>
        </div>
        {showLoginOverlay && (
          <div className="fixed inset-0 z-[9999] flex items-center justify-center backdrop-blur-md bg-white/70">
            {/* Logo fixed at top center */}
            <img
              src={logoIcon}
              alt="Logo"
              className="absolute top-8 left-1/2 -translate-x-1/2 w-28 h-28 object-contain"
            />

            {/* Spinner + Message */}
            <div className="text-center flex flex-col items-center">
              <div className="w-10 h-10 border-4 border-[#55C6EF] border-t-transparent rounded-full animate-spin"></div>
              <p className="mt-4 text-lg font-medium text-[#00384d]">
                {translate("Logging you in..", "جاري تسجيل الدخول")}
              </p>
            </div>
          </div>
        )}
      </div>
    </Suspense>
  );
};

export default Dashboard;
